/**
 * DON'T EDIT THIS FILE
 * It was auto-generated by a script
 */

// Export the components as a plugin
import * as Components from './components';

const MozaicVue = {
  // eslint-disable-next-line no-unused-vars
  install: (app, options) => {
    // components
    Object.keys(Components).forEach((name) => {
      app.component(name, Components[name]);
    });
  },
};

export default MozaicVue;

// import/export individual components
export { MAccordion } from './components/accordion';
export { MActionBar } from './components/actionbar';
export { MAutocomplete } from './components/autocomplete';
export { MBadge } from './components/badge';
export { MBottomBar } from './components/bottombar';
export { MBreadcrumb } from './components/breadcrumb';
export { MBreadcrumbItemV2 } from './components/breadcrumbv2';
export { MBreadcrumbV2 } from './components/breadcrumbv2';
export { MButton } from './components/button';
export { MCard } from './components/card';
export { MCheckbox } from './components/checkbox';
export { MCheckboxGroup } from './components/checkbox';
export { MContainer } from './components/container';
export { MDataTable } from './components/datatable';
export { MDataTableHeader } from './components/datatable';
export { MDataTableCell } from './components/datatablev2';
export { MDataTableColumn } from './components/datatablev2';
export { MDataTableEmpty } from './components/datatablev2';
export { MDataTableExpandButton } from './components/datatablev2';
export { MDataTableHeaderV2 } from './components/datatablev2';
export { MDataTableInfo } from './components/datatablev2';
export { MDataTableRow } from './components/datatablev2';
export { MDataTableRowExpand } from './components/datatablev2';
export { MDataTableRowsPerPage } from './components/datatablev2';
export { MDataTableSelectionBar } from './components/datatablev2';
export { MDataTableTop } from './components/datatablev2';
export { MDataTableV2 } from './components/datatablev2';
export { MDropdown } from './components/dropdown';
export { MField } from './components/field';
export { MFileResult } from './components/fileuploader';
export { MFileUploader } from './components/fileuploader';
export { MFlag } from './components/flag';
export { MHeader } from './components/header';
export { MHeading } from './components/heading';
export { MHero } from './components/hero';
export { MIcon } from './components/icon';
export { MKpi } from './components/kpi';
export { MLayer } from './components/layer';
export { MLink } from './components/link';
export { MListBox } from './components/listbox';
export { MListBoxActions } from './components/listbox';
export { MLoader } from './components/loader';
export { MMenu } from './components/menu';
export { MModal } from './components/modal';
export { MNotification } from './components/notification';
export { MOptionButton } from './components/optionbutton';
export { MOptionCard } from './components/optioncard';
export { MOptionGroup } from './components/optiongroup';
export { MOverlay } from './components/overlay';
export { MOverlayLoader } from './components/overlay';
export { MPagination } from './components/pagination';
export { MPasswordInput } from './components/passwordinput';
export { MPhoneNumber } from './components/phonenumber';
export { MProgress } from './components/progressbar';
export { MQuantitySelector } from './components/quantityselector';
export { MRadio } from './components/radio';
export { MRadioGroup } from './components/radio';
export { MStarsInput } from './components/ratingstars';
export { MStarsResult } from './components/ratingstars';
export { MSegmentedControl } from './components/segmentedcontrol';
export { MSelect } from './components/select';
export { MSidebar } from './components/sidebar';
export { MSidebarFeature } from './components/sidebar';
export { MSidebarFeatureGroup } from './components/sidebar';
export { MSidebarNavigationUser } from './components/sidebar';
export { MSidebarSection } from './components/sidebar';
export { MSidebarSegment } from './components/sidebar';
export { MSidebarSeparator } from './components/sidebar';
export { MSidebarSubFeatures } from './components/sidebar';
export { MStepper } from './components/stepper';
export { MStepperV2 } from './components/stepper';
export { MStepperBar } from './components/stepperbar';
export { MTab } from './components/tabs';
export { MTabsV2 } from './components/tabs';
export { MTagList } from './components/taglist';
export { MTag } from './components/tags';
export { MTextArea } from './components/textarea';
export { MTextInput } from './components/textinput';
export { MTextInputField } from './components/textinput';
export { MTextInputIcon } from './components/textinput';
export { MToggle } from './components/toggle';
export { MTooltip } from './components/tooltip';
